import { http } from './client'
import type { GeositeResponse } from './types'

export const listGeosites = (params?: {
  // Произвольный идентификатор обработчика, не перечисление.
  kind?: string
  searchTag?: string
}): Promise<GeositeResponse[]> =>
  http.get<GeositeResponse[]>('/v0/geosites/', {
    query: { kind: params?.kind, search_tag: params?.searchTag },
  })
